document.addEventListener('DOMContentLoaded', () => {
  const MOBILE_MQ = window.matchMedia('(max-width: 749px)');
  const isMobile = () => MOBILE_MQ.matches;

  let startX=0, startY=0, startT=0, tracking=false, tapCard=null;
  let suppressNextClick = false; 

  const isArrowOrLink = (el) =>
    !!el && (el.closest('.arrow-hit') || el.closest('a[href]'));

  const isOnImageArea = (el) =>
    !!el && (el.closest('.multicolumn-card__image')
      || el.closest('.multicolumn-card__image-wrapper')
      || el.closest('.multicolumn-card .media'));

  const isOnCardContainer = (el) =>
    !!el && el.closest('.multicolumn-card.content-container');


  function setArrowFor(card, open){
    const arrow = card && card.querySelector('.arrow-hit');
    if (!arrow) return;
    arrow.style.transform = open ? 'rotate(-180deg)' : '';
    if (!arrow.style.transition) arrow.style.transition = 'transform .3s ease-in-out';
  }

  function setOpen(card, open){
    const info = card && card.querySelector('.multicolumn-card__info');
    const rte  = info && info.querySelector('.rte');
    if (!rte) return;

    if (open) {
      rte.style.visibility = 'visible';
      rte.style.opacity = '1';
      rte.style.maxHeight = 'none';
      rte.style.transform = 'none';

      const targetH = rte.scrollHeight || 1000;
      rte.style.maxHeight = '210px';
    } else {
      rte.style.opacity = '0';
      rte.style.maxHeight = '0px';
      rte.style.visibility = 'hidden';
      rte.style.transform = 'translateY(6px)';
    }

    // flecha
    setArrowFor(card, open);
    // marca interna de estado
    card.dataset.open = open ? '1' : '0';
  }

  function toggleCard(card){
    const open = card.dataset.open === '1';
    setOpen(card, !open);
  }

  function closeOthers(except){
    document.querySelectorAll('.multicolumn-card.content-container[data-open="1"]').forEach(c => {
      if (c !== except) setOpen(c, false);
    });
  }


  function beginTrack(e, point) {
    if (!isMobile()) return;
    const tgt = e.target;
    if (isArrowOrLink(tgt)) return;
    const card = tgt.closest('.multicolumn-card');
    if (!card) return;

    if (!isOnImageArea(tgt) && !isOnCardContainer(tgt)) return;

    if (tracking) return; 
    tracking = true;
    tapCard  = card;
    startX   = point.clientX;
    startY   = point.clientY;
    startT   = e.timeStamp || Date.now();
  }

  function endTrack(e, point) {
    if (!isMobile() || !tracking) return;
    tracking = false;

    const tgt = e.target;
    if (isArrowOrLink(tgt)) return;

    const dx = Math.abs(point.clientX - startX);
    const dy = Math.abs(point.clientY - startY);
    const dt = (e.timeStamp || Date.now()) - startT;

    if (dx < 10 && dy < 10 && dt < 500 && tapCard) {
      try { e.preventDefault(); } catch(_) {}
      e.stopPropagation();

      const willOpen = tapCard.dataset.open !== '1';
      if (willOpen) closeOthers(tapCard);
      toggleCard(tapCard);

      suppressNextClick = true;
      setTimeout(() => { suppressNextClick = false; }, 400);

      tapCard = null;
    }
  }

  document.addEventListener('touchstart', (e) => {
    if (!isMobile()) return;
    const t = e.changedTouches && e.changedTouches[0];
    if (!t) return;
    beginTrack(e, t);
  }, { passive: true, capture: true });

  document.addEventListener('touchend', (e) => {
    if (!isMobile()) return;
    const t = e.changedTouches && e.changedTouches[0];
    if (!t) return;
    endTrack(e, t);
  }, { passive: false, capture: true });

  document.addEventListener('pointerdown', (e) => {
    if (!isMobile()) return;
    beginTrack(e, e);
  }, { passive: true, capture: true });

  document.addEventListener('pointerup', (e) => {
    if (!isMobile()) return;
    endTrack(e, e);
  }, { passive: false, capture: true });

  document.addEventListener('click', (e) => {
    if (!isMobile()) return;

    if (suppressNextClick) { suppressNextClick = false; return; }

    const tgt = e.target;

    if (isArrowOrLink(tgt)) return;
    if (!isOnImageArea(tgt) && !isOnCardContainer(tgt)) return;

    const card = tgt.closest('.multicolumn-card');
    if (!card) return;

    e.preventDefault();
    e.stopPropagation();

    const willOpen = card.dataset.open !== '1';
    if (willOpen) closeOthers(card);
    toggleCard(card);
  }, true);
});
